export default "__VITE_ASSET__CHOqDCxF__"